var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 10C3.25 9.0335 4.0335 8.25 5 8.25H5.01C5.9765 8.25 6.76 9.0335 6.76 10C6.76 10.9665 5.9765 11.75 5.01 11.75H5C4.0335 11.75 3.25 10.9665 3.25 10Z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10C8.25 9.0335 9.0335 8.25 10 8.25H10.01C10.9765 8.25 11.76 9.0335 11.76 10C11.76 10.9665 10.9765 11.75 10.01 11.75H10C9.0335 11.75 8.25 10.9665 8.25 10Z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.25C14.0335 8.25 13.25 9.0335 13.25 10C13.25 10.9665 14.0335 11.75 15 11.75H15.01C15.9765 11.75 16.76 10.9665 16.76 10C16.76 9.0335 15.9765 8.25 15.01 8.25H15Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalDots);
export default __webpack_public_path__ + "static/media/horizontal-dots.27e31a842ba7a50056b35e203b117450.svg";
export { ForwardRef as ReactComponent };